var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMetricCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 96,
    viewBox: "0 0 125 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 51.7143L55.9 62L79 38",
    stroke: "url(#paint0_linear_5059_698)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 92C87.0767 92 107 72.3005 107 48C107 23.6995 87.0767 4 62.5 4C37.9233 4 18 23.6995 18 48C18 72.3005 37.9233 92 62.5 92Z",
    stroke: "url(#paint1_linear_5059_698)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5059_698",
    x1: 62.5,
    y1: 38,
    x2: 62.5,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3E5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5059_698",
    x1: 62.5,
    y1: 4,
    x2: 62.5,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMetricCheck);
export default __webpack_public_path__ + "static/media/icMetricCheck.bb7f637f7eac9c396a1c0f104c6577d4.svg";
export { ForwardRef as ReactComponent };